<template>
    <div style="width: 100vw; height: 100vh;">
        <div id="streamPlayer" style="width:100%;height:100%;"></div>
    </div>
</template>

<script>

    import * as Config from '../../config'
    import { mapState, mapGetters } from 'vuex';
    import Clappr from 'clappr';

	export default {
		name: 'Chasers',
		data () {
			return {
                chaserId: null,
                token: null,
			}
        },
        mounted() {
            window.document.title = this.$route.query.name + "'s Stream Player"
            this.chaserId = this.$route.params.chaserId
            this.token = this.$route.query.token
            
            this.checkAuth()
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            checkAuth() {
                var self = this;
                this.$http.post(Config.apiPath + "/api/v2/media/stream/verify", {
                    streamId: this.chaserId,
                    token: this.token,
                }, this.getAuthorizationHeader())
                    .then((response) => {
                        console.log(response)
                        if(!response.data.error) {
                            self.initVid()
                        } else {
                            alert('Stream access issue - most likely access expired.');
                        }
                    })
                    .catch((data) => {
                        alert('Stream access issue - most likely access expired.');
                    });
            },
            initVid() {
                var playerElement = document.getElementById('streamPlayer')

                this.player = new Clappr.Player({
                    source: "https://edge-media.livestormchasing.com/hls/" + this.chaserId + "/index.m3u8",
                    autoPlay: true,
                    width: "100%",
                    height: "100%",
                    mute: true,
                })

                this.player.attachTo(playerElement)
            }
        }
	}
</script>

<style scoped>

</style>
